import React from "react";
import { Card, Row, Col } from "antd";
import "./index.css";

const UnionInfoCard = (props) => {
  return (
    <Card className="card-align" style={{ borderRadius: "20px" }}>
      <span className="transaction-card-title-heading">
        {" "}
        Transaction Details
      </span>
      <br></br>
      <br></br>
      <Row className="amount-details" gutter={[16, 16]}>
        <Col span={24}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr className="details-text">
                <td className="padding-td">
                  <span className="details-text-strong">Transaction ID :</span>
                </td>
                <td className="padding-td">{props.transaction_data?.txnid}</td>
              </tr>
              <tr className="details-text">
                <td className="padding-td">
                  <span className="details-text-strong">GSTIN :</span>
                </td>
                <td className="padding-td">{props.transaction_data?.GSTIN}</td>
              </tr>
              <tr className="details-text">
                <td className="padding-td">
                  <span className="details-text-strong">CPIN :</span>
                </td>
                <td className="padding-td">{props.transaction_data?.CPIN}</td>
              </tr>
              <tr className="details-text">
                <td className="padding-td">
                  <span className="details-text-strong">State :</span>
                </td>
                <td className="padding-td">{props.transaction_data?.State}</td>
              </tr>
              <tr className="details-text">
                <td className="padding-td">
                  <span className="details-text-strong">IGST Amount :</span>
                </td>
                <td className="padding-td">
                  ₹ {props.transaction_data?.IGST_Amount}
                </td>
              </tr>
              <tr className="details-text">
                <td className="padding-td">
                  <span className="details-text-strong">CGST Amount :</span>
                </td>
                <td className="padding-td">
                  ₹ {props.transaction_data?.CGST_Amount}
                </td>
              </tr>
              <tr className="details-text">
                <td className="padding-td">
                  <span className="details-text-strong">SGST Amount :</span>
                </td>
                <td className="padding-td">
                  ₹ {props.transaction_data?.SGST_Amount}
                </td>
              </tr>
              <tr className="details-text">
                <td className="padding-td">
                  <span className="details-text-strong">CESS Amount :</span>
                </td>
                <td className="padding-td">
                  ₹ {props.transaction_data?.CESS_Amount}
                </td>
              </tr>
              <tr className="details-text">
                <td className="padding-td">
                  <span className="details-text-strong">Total Amount :</span>
                </td>
                <td className="padding-td">
                  ₹ {props.transaction_data?.Amount}
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
    </Card>
  );
};

export default UnionInfoCard;
